import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await axios.post(`${API_URL}/api/admin/login`, {
        email,
        password
      });

      localStorage.setItem('adminToken', response.data.token);
      localStorage.setItem('adminEmail', response.data.email);
      navigate('/admin/dashboard');
    } catch (err) {
      setError('Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F5F5F0] pt-20 px-6">
      <div className="max-w-md w-full bg-white p-8 shadow-lg" data-testid="admin-login-form">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-[#C4A661] flex items-center justify-center text-white font-bold text-2xl mx-auto mb-4">
            DS
          </div>
          <h1 className="text-3xl font-light font-heading mb-2">Admin Login</h1>
          <p className="text-sm text-gray-600">Dar Al Safaa Marbles</p>
        </div>

        {error && (
          <div className="mb-6 p-4 bg-red-50 text-red-800 text-sm" data-testid="login-error">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="space-y-6">
            <div>
              <label className="block text-sm font-medium mb-2">Email</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="admin-email"
                placeholder="admin@dsmarbles.ae"
                className="w-full px-4 py-3 border border-black/20 focus:border-[#C4A661] focus:outline-none transition-colors"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-2">Password</label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-password"
                className="w-full px-4 py-3 border border-black/20 focus:border-[#C4A661] focus:outline-none transition-colors"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              data-testid="admin-login-submit"
              className="w-full px-8 py-4 bg-[#0F0F0F] text-white text-sm font-medium hover:bg-[#C4A661] transition-all duration-300 disabled:opacity-50"
            >
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </div>
        </form>

        <div className="mt-6 text-center text-sm text-gray-500">
          <p>Default credentials:</p>
          <p>Email: admin@dsmarbles.ae</p>
          <p>Password: admin123</p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
